import fetch from "@lib/fetch";
import React, { useState, useEffect, useRef  } from 'react';
import InputLocation from '../../../../components/atoms/InputLocation';
import { Nav, Dropdown, DropdownButton, InputGroup, FormControl } from 'react-bootstrap';
import TimePicker from 'react-bootstrap-time-picker';
import DatePicker from "react-datepicker";
import numeral from 'numeral';
import ReactLoading from "react-loading";
import {
  courierWithInstantPickup,
  courierWithMultipleItems,
  normalizeCourierServices,
  allDayPickupCourier
} from "../../../../services/helpers/courier";
import { isAuthenticated } from "../../../../store/action/auth";
import Modal from "../../../../components/molecules/Modal"
import ReactTooltip from "react-tooltip";
import Dropzone from "../../../../components/atoms/Dropzone";
import UploadOrderTable from "../../../../components/tables/UploadOrderTable";
import UploadStoreOrderTable from "../../../../components/tables/UploadStoreOrderTable";
import {API} from "../../../../config";
import download from "downloadjs";
import moment from "moment";
import {getAddresses} from "../../../../store/action/address";
import {
  createAdminOrder, 
  createOrder, 
  fetchPaymentData, 
  uploadOrderFile,
  getShopifyOrders,
  createMultipleOrders
} from "../../../../store/action/order";
import {getAdminInfo} from "../../../../store/action/admin";
import {getAdminUserAddress, getUser, updateUserOnLocal} from "../../../../store/action/user";
import {getWallet} from "../../../../store/action/billing";
import {getLogisticPricing} from "../../../../store/action/pricing";
import {sortByValue} from "../../../../services/helpers/array";
import {secondToTimestrings} from "../../../../services/helpers/time";
import {isContainText} from "../../../../services/helpers/validator";
import {trackWithValue} from "../../../../services/analytics";
import Maps from "../../../../components/atoms/Maps";
import QRCode from "qrcode.react";
import ExtraFeatures from "./components/ExtraFeatures";
import { useSSR } from 'react-i18next';

const OrderForm = (props) => {
  const ref = useRef(null);
  let user;
  if (props.admin) {
    user = props.user
  } else {
    user = isAuthenticated().user
  }
  const { token } = isAuthenticated();
  const [ addresses, setAddresses ] = useState([]);
  const [ addressFetched, setAddressFetched ] = useState(false);
  const [ courierFilter, setCourierFilter ] = useState(null);
  const [ height, setHeight ] = useState(0);
  const [ tab, setTab ] = useState('now');
  const [ uploadOrders, setUploadOrders ] = useState([]);
  const [ uploadStoreOrders, setUploadStoreOrders ] = useState([]);
  const [ uploadLoading, setUploadLoading ] = useState(false);
  const [ uploadStoreLoading, setUploadStoreLoading ] = useState(false);
  const [ qrCode, setQrCode ] = useState('');
  const [ modal, setModal ] = useState({
    show: false,
    type: 'order',
    mapCoordinate:{},
    mapType: 'origin'
  });
  const [ loadings, setLoadings ] = useState({
    message:'',
    origin:false,
    destination:false,
    couriers:false,
    view:false
  });
  const destinationInitialState = {
    loading:false,
    name:'',
    location:'',
    phone:'',
    note:'',
    postalCode:"Kodepos",
    coordinate:{},
    courierOptions:[],
    courierCompanyName:'',
    courierTypeName:'',
    courierCompanyCode:'',
    courierTypeCode:'',
    items:[{
      name:'Makanan',
      description:'Makanan',
      value:10000,
      quantity:1,
      length:10,
      width:10,
      height:10,
      weight:1000
    }],
    price:0,
    deliveryDateTime: new Date(),
    deliveryDate:'',
    deliveryTime:''
  };
  const [ destinations, setDestinations ] = useState([
    destinationInitialState
  ]);
  const orderInitialState = {
    details:'',
    courierOption:[],
    courierOptionFiltered:[],
    courierParcel:0,
    courierSameDay:0,
    courierInstant:0,
    courierOvernight:0,
    courierStandard:0,
    courierFreight:0,
    courierWaybillId:'',
    courierCompany: '',
    courierType: '',
    courierName:'',
    courierPhone: '',
    courierLink: '',
    courierLoading: false,
    deliveryType: 'now',
    deliveryDate: new Date() ,
    deliveryTime: moment().format('HH:mm:ss'),
    error:false,
    extra:[],
    finishedOrders:[],
    historyOrders:[],
    information:'',
    info:false,
    needActionOrders:[],
    loading: false,
    locationLoading:false,
    originName:'',
    originLocation:'',
    originPhone:'',
    originNote:'',
    originPostalCode:"Kodepos",
    originCoordinate:{},
    originProvinceName:'',
    originCityName:'',
    originDistrictName:'',
    orderId:'',
    orderNote:'',
    orderCreated: '',
    orderItems: [{
      description:'',
      value:0,
      quantity:0,
      length:0,
      width:0,
      height:0,
      weight:1000
    }],
    ordersSelected:false,
    receiverName: '',
    receiverPhone: '',
    receiverLocation:'',
    receiverPostalCode: 'Kodepos',
    receiverCoordinate: {},
    receiverProvinceName:'-',
    receiverCityName:'-',
    receiverDistrictName:'-',
    receiverNote:'',
    receiverCashOnDeliveryAmount:'',
    receiverCashOnDeliveryType:'',
    receiverProofOfDelivery:false,
    receiverProofOfDeliveryNote: null,
    courierInsurance:false,
    courierInsuranceAmount:null,
    scheduledOrders:[],
    serviceType:'sameDay',
    shippingType:'parcel',
    pendingOrders:[],
    pickedOrders:[],
    price:0,
    weight:0,
    volume:0,
    success:false,
    paymentMethod:'',
    status:'active'
  };
  const [ order, setOrder ] = useState(orderInitialState);
  const isUserFulfillment = user.integrations && user.integrations.filter(i => i.scopes.includes("write_fulfillment")).length > 0;
  
  useEffect(() => {
    if (props.show) {
      setHeight(ref.current.clientHeight);
      if (!addressFetched) {
        getAddress()
        setAddressFetched(true)
      }
    }
  });

  const getAddress = async () => {
    let resAd;
    if (props.admin) {
      resAd = await getAdminUserAddress(user.id,token);
    } else {
      resAd = await getAddresses();
    }

    if(!(resAd)) {
      return alert("Gagal mengambil data. Coba refresh atau ulangi beberapa saat lagi")
    }

    if(resAd.success) {
      let ad = resAd.addresses[0];
      let addresses = resAd.addresses.reduce((result, i) => {
        result.push({
          addressName: i.name,
          addressPIC:i.PIC,
          addressDetails: i.details,
          addressNote:i.note,
          coordinate:i.coordinate,
          postalCode: i.postalCode,
          provinceId: i.provinceId,
          provinceName: i.provinceName,
          cityId: i.cityId,
          cityName: i.cityName,
          districtId: i.districtId,
          districtName: i.districtName,
          subdistrictId: i.subdistrictId,
          subdistrictName: i.subdistrictName,
        });
        return result
      }, []);

      if (resAd.addresses.length > 0) {
        setOrder({
          ...order,
          originName:ad.name,
          originLocation:ad.details,
          originPhone:ad.PIC,
          originNote:ad.note,
          originCoordinate:ad.coordinate,
          originPostalCode: ad.postalCode,
          originProvinceName: ad.provinceName,
          originCityName: ad.cityName,
          originDistrictName: ad.districtName,
          loading:false,
        });
      }

      setAddresses(addresses);
    } else {
      return alert("Gagal mengambil data. Coba refresh atau ulangi beberapa saat lagi")
    }
  };

  const onSubmit = async () => {
    const checkPaymentMethod = await isContainText('Tipe Pembayaran',order.paymentMethod);
    if (!checkPaymentMethod.success && order.deliveryType !== 'upload')
      return setOrder({...order, error: checkPaymentMethod.message});

    if (order.paymentMethod !== 'credit') {
      if (user.balance < 0) {
        return setOrder({...order, error: `Bite points kurang. Mohon isi Bite Points untuk memulai order`});
      }

      if (order.deliveryType === 'many') {
        let totalPrice = destinations.reduce((res,i) => {
          res += i.price;
          return parseInt(res)
        }, []);
        if (totalPrice > user.balance ) {
          return setOrder({...order, error: `Bite points tidak cukup. Mohon isi Bite Points untuk pesan banyak destinasi`});
        }
      }

      if (order.deliveryType === 'upload') {
        let totalPrice = uploadOrders.reduce((res,i) => {
          res += i.price;
          return parseInt(res)
        }, []);
        if (totalPrice > user.balance ) {
          return setOrder({...order, error: `Bite points tidak cukup. Mohon isi Bite Points untuk pesan upload order`});
        }
      }
    }

    setOrder({
      ...order,
      info:true,
      error:'',
      loading:true
    });

    if (props.admin) {
      await createAdminOrder(user.id, token, order, destinations)
          .then(data => {
            if(data.error) {
              setOrder({
                ...order,
                error: data.error
              })
            } else {
              trackWithValue("Order Created",{
                courier: {
                  company: order.courierCompany,
                  type: order.courierType
                },
                type: order.type,
                revenue: order.price,
                value: order.price,
                currency: 'IDR',
                action: "track",
                category: "Orders",
                label: 'Order From Dashboard',
                event: "Click"
              });

              window.location.reload()
            }
          })
    } else if (tab === 'webstore') {
      const result = await createMultipleOrders(token, uploadStoreOrders, order)
      alert(`Berhasil membuat ${result.successOrders} order dan gagal ${result.failedOrders} order`)
      window.location.reload()
    } else {
      await createOrder(token, order, destinations, uploadOrders)
          .then(data => {
            let message;

            if(data.error) {
              setOrder({
                ...order,
                error: data.error
              });
              return
            }

            if (order.deliveryType === 'upload') {
              if (data.failedOrders > 0 && data.successOrders > 0) {
                message = `${data.successOrders} Pesanan Berhasil dipesan. ${data.failedOrders} Pesanan gagal dipesan. `
              } else if (data.failedOrders > 0 && data.successOrders === 0) {
                message = `${data.failedOrders} Pesanan gagal dipesan.`
              } else if (data.failedOrders === 0 && data.successOrders > 0) {
                message = `${data.successOrders} Pesanan Berhasil dipesan.`
              }
              alert(message);
            }

            trackWithValue("Order Created",{
              courier: {
                company: order.courierCompany,
                type: order.courierType
              },
              type: order.type,
              revenue: order.price,
              value: order.price,
              currency: 'IDR',
              action: "track",
              category: "Orders",
              label: 'Order From Dashboard',
              event: "Click"
            });


            if (order.paymentMethod === 'qris') {
              onOpenQR(data.id);
              setOrder({
                ...orderInitialState,
                info:false,
                success:true,
                error: '',
                loading:true
              });
            } else {
              window.location.reload()
            }
          })
    }

  };

  const setTime = (t) => {
    if (order.deliveryType === 'later' && 
    allDayPickupCourier(order.courierCompany)) {
      let time = secondToTimestrings(t);
      setOrder({...order,
        deliveryTime:time,
        error:false
      })
    } else {
      setOrder({...order,
        deliveryTime:`${t.target.value}:00`,
        error:false
      })
    }
  };

  const setDate = (d) => {
    setOrder({...order, deliveryDate:d, error:false})
  };

  const selectCourier = (courier) => {
    let { company } = courier;
    if (courierWithInstantPickup(company) && tab === 'now') {
      setTab("now")
    } else if (courierWithInstantPickup(company) && tab === 'later') {
      setTab("later")
    } else if (!courierWithInstantPickup(company)) {
      setTab("later")
    }
    onSelectCourier(courier)
  };

  const onSelectCourier = (courier) => {
    let deliveryTime;
    let newOrder = { courierCompany: courier.company, courierType: courier.type, price: courier.price, extra: [] };

    if (courier.company !== 'deliveree') {
      newOrder = { ...newOrder, receiverProofOfDelivery: false, receiverProofOfDeliveryNote:''}
    }

    if (courierWithInstantPickup(courier.company) && !courierWithMultipleItems(courier.company)) {
        if (order.deliveryType === 'later') {
          deliveryTime = `12:00:00`
        } else {
          deliveryTime = moment().format('HH:mm:ss')
        }

        newOrder = { ...newOrder, deliveryTime }
    } else if (courier.company === 'deliveree' ) {
        let  { receiverProofOfDelivery, receiverProofOfDeliveryNote } = order;
        if (order.deliveryType === 'later') {
          deliveryTime = `12:00:00`
        } else {
          deliveryTime = moment().format('HH:mm:ss')
        }
        newOrder = { ...newOrder, deliveryTime, paymentMethod: 'bitepay', receiverProofOfDelivery, receiverProofOfDeliveryNote }
    } else if (courierWithInstantPickup(courier.company) && courierWithMultipleItems(courier.company)) {
        newOrder = { ...newOrder, deliveryTime, paymentMethod: 'bitepay', deliveryTime:`12:00:00`, paymentMethod: 'bitepay'}
    } else {
        newOrder = { ...newOrder, deliveryTime, deliveryType: 'later', paymentMethod: 'bitepay', deliveryTime:`12:00:00`, paymentMethod: 'bitepay'}
    }
    setOrder({...order, ...newOrder })
  };

  const onChangeExtra = (e) => {
    let newExtra = [];
    let newOrder = {};
    if (e.bag) { newExtra.push({name:'bag'}) }
    if (e.roundtrip) { newExtra.push({name:'roundtrip'}) }
    if (e.parking) { newExtra.push({name:'parking'}) }
    if (e.tolls) { newExtra.push({name:'tolls'}) }
    setOrder({...order, ...newOrder, extra:newExtra})
  }

  const handleItemChange = (idx,field) => e => {
    const { value } = e.target;
    let stateCopy = Object.assign({}, order);
    stateCopy.orderItems = stateCopy.orderItems.slice();
    stateCopy.orderItems[idx] = Object.assign({}, stateCopy.orderItems[idx]);
    if (field === 'description' || field === 'value' || field === 'name' || field === 'sku') {
      stateCopy.orderItems[idx][field] = value;
    } else {
      stateCopy.orderItems[idx][field] = parseInt(value);
    }
    // calculate total weight
    let totalWeight = stateCopy.orderItems.reduce((res,i,idx) => {
      res += (i.weight * i.quantity);
      return parseInt(res)
    }, []);

    let totalItemValue = stateCopy.orderItems.reduce((res,i,idx) => {
      if (i.value>0){
        res += parseInt(i.value);
      } else {
        res = 0
      }
      return parseInt(res)
    }, 0);

    let totalVolume = stateCopy.orderItems.reduce((res,i,idx) => {
      let l = i.length;
      let w = i.width;
      let h = i.height;
      let q = i.quantity;
      res = res + (l*w*h*q);
      return parseInt(res)
    }, []);

    let insuranceActivation
    
    if (totalItemValue === 0) {
      if (order.courierInsurance) {
        insuranceActivation = false
      } else {
        insuranceActivation = false
      }
    } else {
      if (order.courierInsurance) {
        insuranceActivation = true
      } else {
        insuranceActivation = false
      }
    }
    
    stateCopy['weight'] = totalWeight;
    stateCopy['volume'] = totalVolume;
    stateCopy['courierInsurance'] = insuranceActivation;
    stateCopy['courierInsuranceAmount'] = totalItemValue;
    stateCopy['error'] = false;
    if (field === 'description' || field === 'value' || field === 'name') {
      setOrder(stateCopy);
    } else {
      stateCopy['courierOption'] = [];
      stateCopy['courierOptionFiltered'] = [];
      stateCopy['courierType'] = '';
      stateCopy['price'] = 0;
      setOrder(stateCopy);
    }
  };

  const onSelectItem = (item,idx) => {
    let orderCopy = Object.assign({}, order);
    orderCopy.orderItems[idx] = {
      name:item.name,
      description:item.description,
      length:item.length,
      width:item.width,
      height:item.height,
      weight:item.weight,
      quantity:item.quantity,
      value:item.value
    }
    // calculate total weight
    let totalWeight = orderCopy.orderItems.reduce((res,i,idx) => {
      res += (i.weight * i.quantity);
      return parseInt(res)
    }, []);

    let totalVolume = orderCopy.orderItems.reduce((res,i,idx) => {
      let l = i.length;
      let w = i.width;
      let h = i.height;
      let q = i.quantity;
      res = res + (l*w*h*q);
      return parseInt(res)
    }, []);
    orderCopy['weight'] = totalWeight;
    orderCopy['volume'] = totalVolume;
    orderCopy['error'] = false;
    orderCopy['courierOption'] = [];
    orderCopy['courierOptionFiltered'] = [];
    orderCopy['courierType'] = '';
    orderCopy['price'] = 0;
    setOrder(orderCopy);
  }

  const onAddDestination = () => {
    let currentDestinations = destinations;
    currentDestinations.push(destinationInitialState);
    setDestinations(currentDestinations);
    setOrder({...order, loading:false})
  };

  const onSelectOrigin = async (a) => {
    let pricing;
    if (order.receiverLocation) {
      setLoadings({...loadings, origin:true});
      setOrder ( {...order, courierLoading: true} );
      let res = await getLogisticPricing (
          token,
          a.coordinate,
          order.receiverCoordinate,
          order.orderItems,
          user.couriers
      );
      if (!res.success) {
        alert(res.error);
        setOrder({
          ...order,
          courierLoading:false,
          locationLoading: false,
          courierOption:[],
          courierOptionFiltered:[],
          price:0
        });
        return
      }

      const sortedPricing = await sortByValue('greaterThan','price',res.pricing);
      pricing = sortedPricing;
    } else {
      pricing = [];
    }

    let originCoordinate = {
      latitude: a.coordinate.latitude,
      longitude: a.coordinate.longitude
    };
    let updatedValues = {
      originName: a.addressName,
      originLocation: a.addressDetails,
      originPhone: a.addressPIC,
      originNote: a.addressNote,
      originPostalCode: a.postalCode,
      originProvinceName: a.provinceName,
      originCityName: a.cityName,
      originDistrictName: a.districtName,
      originCoordinate
    };
    const cSa = pricing.filter(i => i.serviceType === 'sameDay' ) || [];
    const cPa = pricing.filter(i => i.shippingType === 'parcel' ) || [];
    const cIn = pricing.filter(i => i.serviceType === 'instant' ) || [];
    const cOv = pricing.filter(i => i.serviceType === 'overnight' ) || [];
    const cSt = pricing.filter(i => i.serviceType === 'standard' ) || [];
    const cFr = pricing.filter(i => i.shippingType === 'freight') || [];
    const sht = cPa.length > 0 ? 'parcel' : 'freight';
    const set = cSa.length?'sameDay':cIn.length?'instant':cOv.length?'overnight':'standard';
    setOrder({
      ...order,
      ...updatedValues,
      courierOption:pricing,
      courierOptionFiltered: pricing.filter(i => i.shippingType === sht && i.serviceType === set),
      courierSameDay:cSa.length,
      courierParcel:cPa.length,
      courierInstant:cIn.length,
      courierOvernight:cOv.length,
      courierStandard:cSt.length,
      courierFreight: cFr.length,
      shippingType: sht,
      serviceType: set,
      courierLoading:false
    });
    setLoadings({...loadings, origin:false});
  };

  const onSelectDestination = async (a) => {
    let pricing;
    if (order.originLocation) {
      setOrder ( {...order, courierLoading: true} );
      setLoadings({...loadings, destination:true});
      let res = await getLogisticPricing (
          token,
          order.originCoordinate,
          a.coordinate,
          order.orderItems,
          user.couriers
      );

      if (!res.success) {
        alert(res.error);
        setOrder({
          ...order,
          courierLoading:false,
          locationLoading: false,
          courierOption:[],
          courierOptionFiltered:[],
          price:0
        });
        return
      }

      const sortedPricing = await sortByValue('greaterThan','price',res.pricing);
      pricing = sortedPricing;
    } else {
      pricing = [];
    }

    let receiverCoordinate = {
      latitude: a.coordinate.latitude,
      longitude: a.coordinate.longitude
    };
    let updatedValues = {
      receiverName: a.addressName,
      receiverLocation: a.addressDetails,
      receiverPhone: a.addressPIC,
      receiverNote: a.addressNote,
      receiverPostalCode: a.postalCode,
      receiverProvinceName: a.provinceName,
      receiverCityName: a.cityName,
      receiverDistrictName: a.districtName,
      receiverCoordinate
    };
    const cSa = pricing.filter(i => i.serviceType === 'sameDay' ) || [];
    const cPa = pricing.filter(i => i.shippingType === 'parcel' ) || [];
    const cIn = pricing.filter(i => i.serviceType === 'instant' ) || [];
    const cOv = pricing.filter(i => i.serviceType === 'overnight' ) || [];
    const cSt = pricing.filter(i => i.serviceType === 'standard' ) || [];
    const cFr = pricing.filter(i => i.shippingType === 'freight') || [];
    const sht = cPa.length > 0 ? 'parcel' : 'freight';
    const set = cSa.length?'sameDay':cIn.length?'instant':cOv.length?'overnight':'standard';

    setOrder({
      ...order,
      ...updatedValues,
      courierOption:pricing,
      courierOptionFiltered: pricing.filter(i => i.shippingType === sht && i.serviceType === set),
      courierSameDay:cSa.length,
      courierParcel:cPa.length,
      courierInstant:cIn.length,
      courierOvernight:cOv.length,
      courierStandard:cSt.length,
      courierFreight: cFr.length,
      shippingType: sht,
      serviceType: set,
      courierLoading:false
    });
    setLoadings({...loadings, destination:false});
  };

  const setDestinationLocation = async (address, coordinate,placeId,postalCode) => {
    let tab = await onSelectDestinationLocation(address,coordinate,postalCode);
    setTab(tab)
  };

  const onSelectDestinationLocation = async (a,c,pc) => {
    setLoadings({...loadings, destination:true});
    setOrder({
      ...order,
      loading:false,
      courierLoading: true,
      locationLoading: true
    });


    if (!order.originLocation) {
      setOrder({
        ...order,
        courierLoading:false,
        locationLoading: false,
        receiverLocation:a,
        receiverCoordinate:c,
        receiverPostalCode:pc
      });
      setLoadings({...loadings, origin:false});
      return `now`;
    }

    const res = await getLogisticPricing(
        token,
        order.originCoordinate,
        c,
        order.orderItems,
        user.couriers
    );

    let deliveryType;
    let deliveryTime;
    if (res.pricing && res.success){
      const sortedPricing = await sortByValue('greaterThan','price',res.pricing);
      const co = sortedPricing[0];
      const loc = res.destination;
      if (courierWithInstantPickup(co.company)) {
        deliveryType = 'now';
        deliveryTime = moment().format('HH:mm:ss')
      } else {
        deliveryType = 'later';
        deliveryTime = `12:00:00`
      }
      const cSa = sortedPricing.filter(i => i.serviceType === 'sameDay' ) || [];
      const cPa = sortedPricing.filter(i => i.shippingType === 'parcel' ) || [];
      const cIn = sortedPricing.filter(i => i.serviceType === 'instant' ) || [];
      const cOv = sortedPricing.filter(i => i.serviceType === 'overnight' ) || [];
      const cSt = sortedPricing.filter(i => i.serviceType === 'standard' ) || [];
      const cFr = sortedPricing.filter(i => i.shippingType === 'freight') || [];
      const sht = cPa.length > 0 ? 'parcel' : 'freight';
      const set = cSa.length?'sameDay':cIn.length?'instant':cOv.length?'overnight':'standard';
      setOrder({
        ...order,
        courierLoading:false,
        locationLoading: false,
        courierCompany:co.company,
        courierType:co.type,
        courierOption:sortedPricing,
        courierOptionFiltered: sortedPricing.filter(i => i.shippingType === sht && i.serviceType === set),
        courierSameDay:cSa.length,
        courierParcel:cPa.length,
        courierInstant:cIn.length,
        courierOvernight:cOv.length,
        courierStandard:cSt.length,
        courierFreight:cFr.length,
        shippingType: sht,
        serviceType: set,
        deliveryType,
        deliveryTime,
        extra:[],
        receiverLocation:a,
        receiverCoordinate:c,
        receiverPostalCode: loc.postalCode,
        receiverProvinceName: loc.provinceName,
        receiverCityName: loc.cityName,
        receiverDistrictName: loc.districtName,
        price:co.price
      })
    } else if (!res.success) {
      alert(res.error);
      setOrder({
        ...order,
        courierLoading:false,
        locationLoading: false,
        courierOption:[],
        extra:[],
        courierOptionFiltered:[],
        price:0
      });
    } else {
      setOrder({
        ...order,
        courierLoading:false,
        locationLoading: false,
        deliveryType:'later',
        courierCompany:'',
        courierType:'',
        courierOption:[],
        courierOptionFiltered:[],
        extra:[],
        receiverLocation:a,
        receiverCoordinate:c,
        price:0
      });
    }
    setLoadings({...loadings, destination:false});
    return deliveryType;
  };

  const setOriginLocation = async (address, coordinate,placeId,postalCode) => {
    let tab = await onSelectOriginLocation(address,coordinate,postalCode);
    setTab(tab)
  };

  const onSelectOriginLocation = async (a,c,pc) => {
    setLoadings({...loadings, origin:true});
    setOrder({
      ...order,
      loading:false,
      courierLoading: true,
      locationLoading: true
    });


    if (!order.receiverLocation) {
      setOrder({
        ...order,
        courierLoading:false,
        locationLoading: false,
        originLocation:a,
        originCoordinate:c,
        originPostalCode:pc
      });
      setLoadings({...loadings, origin:false});
      return `now`;
    }


    const res = await getLogisticPricing(
        token,
        c,
        order.receiverCoordinate,
        order.orderItems,
        user.couriers
    );

    let deliveryType;
    let deliveryTime;
    if (res.pricing && res.success){
      const sortedPricing = await sortByValue('greaterThan','price',res.pricing);
      const co = sortedPricing[0];
      const loc = res.origin;
      if (courierWithInstantPickup(co.company)) {
        deliveryType = 'now';
        deliveryTime = moment().format('HH:mm:ss')
      } else {
        deliveryType = 'later';
        deliveryTime = `12:00:00`
      }
      const cSa = sortedPricing.filter(i => i.serviceType === 'sameDay' ) || [];
      const cPa = sortedPricing.filter(i => i.shippingType === 'parcel' ) || [];
      const cIn = sortedPricing.filter(i => i.serviceType === 'instant' ) || [];
      const cOv = sortedPricing.filter(i => i.serviceType === 'overnight' ) || [];
      const cSt = sortedPricing.filter(i => i.serviceType === 'standard' ) || [];
      const cFr = sortedPricing.filter(i => i.shippingType === 'freight') || [];
      const sht = cPa.length > 0 ? 'parcel' : 'freight';
      const set = cSa.length?'sameDay':cIn.length?'instant':cOv.length?'overnight':'standard';
      setOrder({
        ...order,
        courierLoading:false,
        locationLoading: false,
        courierCompany:co.company,
        courierType:co.type,
        courierOption:sortedPricing,
        courierOptionFiltered: sortedPricing.filter(i => i.shippingType === sht && i.serviceType === set),
        courierSameDay:cSa.length,
        courierParcel:cPa.length,
        courierInstant:cIn.length,
        courierOvernight:cOv.length,
        courierStandard:cSt.length,
        courierFreight:cFr.length,
        extra:[],
        shippingType: sht,
        serviceType: set,
        deliveryType,
        deliveryTime,
        originLocation:a,
        originCoordinate:c,
        originPostalCode: loc.postalCode,
        originProvinceName: loc.provinceName,
        originCityName: loc.cityName,
        originDistrictName: loc.districtName,
        price:co.price
      })
    } else if (!res.success) {
      alert(res.error);
      setOrder({
        ...order,
        courierLoading:false,
        locationLoading: false,
        courierOption:[],
        courierOptionFiltered:[],
        extra:[],
        price:0
      });
    } else {
      setOrder({
        ...order,
        courierLoading:false,
        locationLoading: false,
        deliveryType:'later',
        courierCompany:'',
        courierType:'',
        courierOption:[],
        courierOptionFiltered:[],
        extra:[],
        originLocation:a,
        originCoordinate:c,
        price:0
      });
    }
    setLoadings({...loadings, origin:false});
    return deliveryType;
  };

  const onOriginChange  = (a) => {
    setOrder({...order, originLocation: a})
  };

  const onDestinationChange = (a) => {
    setOrder({...order, receiverLocation: a})
  };

  const setDestinationsLocation = async (a,c,pc,idx) => {
    let destinationsCopy = destinations;
    destinationsCopy[idx]['loading'] = true;
    setDestinations(destinationsCopy);
    setOrder({...order,loading:true});

    destinationsCopy[idx]['location'] = a;
    destinationsCopy[idx]['coordinate'] = c;
    destinationsCopy[idx]['postalCode'] = pc;

    const res = await getLogisticPricing(
        token,
        order.originCoordinate,
        c,
        destinationsCopy[idx].items,
        user.couriers
    );

    if (res.success) {
      const sortedPricing = await sortByValue('greaterThan','price',res.pricing);
      destinationsCopy[idx]['courierOptions'] = sortedPricing;
      destinationsCopy[idx]['courierCompanyName'] =  sortedPricing[0].courierName;
      destinationsCopy[idx]['courierCompanyCode'] =  sortedPricing[0].courierCode;
      destinationsCopy[idx]['courierTypeName'] =  sortedPricing[0].courierServiceName;
      destinationsCopy[idx]['courierTypeCode'] =  sortedPricing[0].courierServiceCode;
      destinationsCopy[idx]['price'] = sortedPricing[0].price;
    } else {
      console.log ("Gagal ambil data kurir")
    }
    destinationsCopy[idx]['loading'] = false;
    setDestinations(destinationsCopy);
    let totalPrice = destinationsCopy.reduce((res,i,idx) => {
      res += i.price;
      return parseInt(res)
    }, []);
    setOrder({...order, price:totalPrice,loading:false})
  };

  const onDestinationsChange  = (a,idx) => {
    let destinationsCopy = destinations;
    destinationsCopy[idx]['location'] = a;
    setDestinations(destinationsCopy);
    setOrder({...order,loading:false})
  };


  const onSelectDestinationsDateTime = async (d,idx) => {
    let destinationsCopy = destinations;
    destinationsCopy[idx]['deliveryDate'] =  moment(d).format("YYYY-MM-DD");
    destinationsCopy[idx]['deliveryTime'] =  moment(d).format("HH:mm:ss");
    destinationsCopy[idx]['deliveryDateTime'] =  d;
    setOrder({...order,loading:false})
  };


  const onDateChange = (d) => {
    setOrder({...order, deliveryDate:d, error:false})
  };

  const openMap = (type) => {
    setModal({...modal, show:true, type:'map', mapType: type})
  };


  const closeMap = () => {
    setModal({ ...modal, show:false, type:'order' })
  };

  const onOpenQR = async (orderId) => {
    const res = await fetchPaymentData(token, orderId);
    if (!res.success) {
      alert(`Failed to get QR Code`);
      return
    }
    setQrCode(res.qr_string);
    setModal({ ...modal, show:true, type:'qr'});
    setOrder(orderInitialState);
    props.onHide()
  };

  const onCloseQR = () => {
    window.location.reload()
  };

  const onAddItem = () => {
    setOrder({...order, orderItems: order.orderItems.concat(
          [{
            description:'',
            quantity:0,
            value:0,
            length:0,
            width:0,
            height:0,
            weight:1000
          }]
      )
    })
  };

  const onChange = name => e => {
    switch (name) {
      case  'name':
        name = 'originName';
        break;
      case 'phone':
        name = 'originPhone';
        break;
      case 'postalCode':
        name = 'originPostalCode';
        break;
      case 'note':
        name = 'originNote';
        break;
      default:
        break
    }
    const value = e.target.value;
    setOrder({
      ...order,
      error:false,
      success:false,
      [name]: value
    });
  };

  const removeItem = () => {
    const li = order.orderItems[order.orderItems.length - 1]; //li = Last Item
    const liVol = li.length*li.width*li.height*li.quantity;
    const liWei = li.weight*li.quantity;
    const liIp = li.value;
    setOrder({
      ...order,
      orderItems: order.orderItems.slice(0, -1),
      courierOption:[],
      courierOptionFiltered: [],
      courierInsuranceAmount: order.courierInsurance ? order.courierInsuranceAmount - liIp : null,
      volume: order.volume - liVol,
      weight: order.weight - liWei,
      error:false
    })
  };

  const onRemoveDestination = (idx) => {
    let currentDestinations = destinations;
    let price = currentDestinations[idx].price;
    currentDestinations.splice(idx, 1);
    setDestinations(currentDestinations);
    setOrder({...order,
      price: order.price - price,
      loading:false
    })
  };

  const checkCourier = async () => {
    setOrder ( {...order, courierLoading: true, error: false} );
    try {
      const res = await getLogisticPricing (
          token,
          order.originCoordinate,
          order.receiverCoordinate,
          order.orderItems,
          user.couriers
      );

      if (!res.success) {
        alert(res.error);
        setOrder({
          ...order,
          courierLoading:false,
          locationLoading: false,
          courierOption:[],
          extra:[],
          courierOptionFiltered:[],
          price:0
        });
        return
      }

      const sortedPricing = await sortByValue('greaterThan','price',res.pricing);
      const cSa = sortedPricing.filter(i => i.serviceType === 'sameDay' ) || 0;
      const cPa = sortedPricing.filter(i => i.shippingType === 'parcel' ) || 0;
      const cIn = sortedPricing.filter(i => i.serviceType === 'instant' ) || 0;
      const cOv = sortedPricing.filter(i => i.serviceType === 'overnight' ) || 0;
      const cSt = sortedPricing.filter(i => i.serviceType === 'standard' ) || 0;
      const cFr = sortedPricing.filter(i => i.shippingType === 'freight') || 0;
      const sht = cPa.length > 0 ? 'parcel' : 'freight';
      const set = cSa.length?'sameDay':cIn.length?'instant':cOv.length?'overnight':'standard';
      setOrder ( {
        ...order,
        courierOption: sortedPricing,
        courierOptionFiltered: sortedPricing.filter(i => i.shippingType === sht && i.serviceType === set),
        courierSameDay:cSa.length,
        courierParcel:cPa.length,
        courierInstant:cIn.length,
        courierOvernight:cOv.length,
        courierStandard:cSt.length,
        courierFreight:cFr.length,
        extra:[],
        shippingType: sht,
        serviceType: set,
        courierLoading: false,
        error: false
      } )
    } catch (err) {
      console.log (err);
      setOrder ( {
        ...order,
        courierLoading: false,
        error: false
      } )
    }
  };

  const deliveryTypeChange = (t) => {
    let deliveryTime;
    if (t === 'later') {
      deliveryTime = `12:00:00`
    } else {
      deliveryTime = moment().format('HH:mm:ss')
    }

    setOrder({
      ...order,
      extra:[],
      deliveryType:t,
      deliveryTime,
      error:false
    });
    setTab(t)
  };

  const onSelectDestinationsFromAddress = async (a,idx) => {
    try {
      let destinationsCopy = destinations;
      destinationsCopy[idx]['loading'] = true;
      setDestinations(destinationsCopy);
      setOrder({...order,loading:true});
      let res = await getLogisticPricing (
          token,
          order.originCoordinate,
          a.coordinate,
          destinationsCopy[idx].items,
          user.couriers
      );
      if (res.success) {
        const sortedPricing = await sortByValue('greaterThan','price',res.pricing);
        destinationsCopy[idx]['name'] = a.addressName;
        destinationsCopy[idx]['location'] = a.addressDetails;
        destinationsCopy[idx]['phone'] = a.addressPIC;
        destinationsCopy[idx]['note'] = a.addressNote;
        destinationsCopy[idx]['coordinate'] = a.coordinate;
        destinationsCopy[idx]['postalCode'] = a.postalCode;
        destinationsCopy[idx]['courierOptions'] = sortedPricing;
        destinationsCopy[idx]['courierCompanyName'] =  sortedPricing[0].courierName;
        destinationsCopy[idx]['courierCompanyCode'] =  sortedPricing[0].courierCode;
        destinationsCopy[idx]['courierTypeName'] =  sortedPricing[0].courierServiceName;
        destinationsCopy[idx]['courierTypeCode'] =  sortedPricing[0].courierServiceCode;
        destinationsCopy[idx]['price'] = sortedPricing[0].price;
      } else {
        console.log ("Gagal ambil data kurir")
      }
      destinationsCopy[idx]['loading'] = false;
      setDestinations(destinationsCopy);
      let totalPrice = destinationsCopy.reduce((res,i,idx) => {
        res += i.price;
        return parseInt(res)
      }, []);
      setOrder({...order, price:totalPrice,loading:false})
    } catch (e) {
      console.log (e)
    }
  };

  const onSyncShopifyOrders = async () => {
    setUploadStoreLoading(true);
    try {
      const res = await getShopifyOrders(token);
      if (res.success) {
        setUploadStoreOrders(formatShopifyOrders(res.orders));
      } else {
        alert(res.error)
      }
    } catch (e) {
      alert(e.message)
    }
    setUploadStoreLoading(false);
  }

  const onDestinationsValueChange = (field,idx) => e => {
    const { value } = e.target;
    let destinationsCopy = destinations;
    destinationsCopy[idx][field] = value;
    setDestinations(destinationsCopy);
    setOrder({...order,loading:false})
  };


  const onSelectDestinationsCourier = async (c,idx) => {
    const courier = JSON.parse(c.target.value);
    let destinationsCopy = destinations;
    destinationsCopy[idx]['courierCompanyName'] =  courier.courierCompanyName;
    destinationsCopy[idx]['courierCompanyCode'] =  courier.courierCompanyCode;
    destinationsCopy[idx]['courierTypeName'] =  courier.courierTypeName;
    destinationsCopy[idx]['courierTypeCode'] =  courier.courierTypeCode;
    destinationsCopy[idx]['price'] = courier.price;

    let totalPrice = destinationsCopy.reduce((res,i,idx) => {
      res += i.price;
      return parseInt(res)
    }, []);

    setDestinations(destinationsCopy);
    setOrder({
      ...order,
      price:totalPrice,
      loading:false
    })
  };

  const onSelectDestinationsItem = async (type,e,idx) => {
    let destinationsCopy = destinations;
    destinationsCopy[idx]['loading'] = true;
    const value = e.target.value;
    if (type === 'weight'){
      setDestinations(destinationsCopy);
      setOrder({...order,loading:true});
      destinationsCopy[idx]['items'][0]['weight'] = parseInt(value)
      if (destinationsCopy[idx]['location']){
        let res = await getLogisticPricing (
            token,
            order.originCoordinate,
            destinationsCopy[idx].coordinate,
            destinationsCopy[idx].items,
            user.couriers
        );
        if (res.success) {
          const sortedPricing = await sortByValue('greaterThan','price',res.pricing);
          destinationsCopy[idx]['courierOptions'] = sortedPricing;
          destinationsCopy[idx]['courierCompanyName'] =  sortedPricing[0].courierName;
          destinationsCopy[idx]['courierCompanyCode'] =  sortedPricing[0].courierCode;
          destinationsCopy[idx]['courierTypeName'] =  sortedPricing[0].courierServiceName;
          destinationsCopy[idx]['courierTypeCode'] =  sortedPricing[0].courierServiceCode;
          destinationsCopy[idx]['price'] = sortedPricing[0].price;
        } else {
          console.log ("Gagal ambil data kurir")
        }
      }
    } else {
      destinationsCopy[idx]['items'][0]['name'] = value;
      destinationsCopy[idx]['items'][0]['description'] = value;
    }
    destinationsCopy[idx]['loading'] = false;
    setDestinations(destinationsCopy);
    setOrder({...order, loading:false})
  };

  const handlePaymentMethod = (e) => {
    setOrder({...order, paymentMethod:e.target.value, error:false});
    if (e.target.value === 'offline'){
      alert('Mohon Diperhatikan dan diinfokan dengan pelanggan Anda \n\nUntuk Cash-On-Delivery (COD) atau bayar di tempat, akan ada sedikit perbedaan harga antara aplikasi SWIFT dan yang harus dibayar customer. ' +
          'Semua tergantung kondisi jalanan, Namun perbedaan harga tidak mungkin lebih dari Rp. 10.000. \n \nSWIFT akan membantu update harga di dalam dashboard ketika kurir sudah ditemukan.')
    }
  };

  const onClickProofOfDelivery = () => {
    if (order.receiverProofOfDelivery) setOrder({...order, receiverProofOfDelivery: false});
    else setOrder({...order, receiverProofOfDelivery: true})
  };

  const onClickCashOnDelivery = (value,type) => {
    setOrder({
      ...order, 
      receiverCashOnDelivery: value,
      receiverCashOnDeliveryType:type
    })
  }

  const onClickInsurance = () => {
    let totalPrice = 0;
    for (let i = 0; i<order.orderItems.length;i++) {
      let itemPrice = order.orderItems[i].value;
      if(!itemPrice && !order.courierInsurance) {
        alert(`Harga barang ${i+1} belum di masukkan`)
        return
      }
      totalPrice = totalPrice + parseInt(itemPrice)
    }
    setOrder({...order, 
      courierInsurance: !order.courierInsurance,
      courierInsuranceAmount:totalPrice
    })
  }

  const onOrderFileDrop = async (e) => {
    setUploadLoading(true);
    try {
      const data = e[0];
      const res = await uploadOrderFile(token, data);
      if (res.success) {
        setUploadOrders(res.file);
      } else {
        alert("Gagal upload file")
      }
    } catch (e) {
      console.log (e);
      alert(`${e.message}`)
    }
    setUploadLoading(false)
  };

  const onPressOriginMap = (idx) => {
    let upCopy = uploadOrders;
    upCopy[idx]['originMap'] = 'input';
    setUploadOrders(prev => ([...upCopy]));
  };

  const onPressDestinationMap = (idx) => {
    let upCopy = uploadOrders;
    upCopy[idx]['receiverMap'] = 'input';
    setUploadOrders(prev => ([...upCopy]));
  };

  const onChangeLocationOrigin = (idx,e) => {
    let upCopy = uploadOrders;
    upCopy[idx]['originInputLocation'] = e;
    setUploadOrders(prev => ([...upCopy]));
  };
  const onChangeLocationDestination = (idx,e) => {
    let upCopy = uploadOrders;
    upCopy[idx]['receiverInputLocation'] = e;
    setUploadOrders(prev => ([...upCopy]));
  };

  const onSelectLocationOrigin = async (idx,a,c,p) => {
    let upCopy = uploadOrders;
    if (upCopy[idx]['receiverLatitude'] && upCopy[idx]['receiverLongitude']) {
      upCopy[idx]['loading'] = true;
      setUploadOrders(prev => ([...upCopy]));
      setOrder({...order,loading:true});

      let res = await getLogisticPricing (
          token,
          c,
          {latitude:upCopy[idx]['receiverLatitude'], longitude:upCopy[idx]['receiverLongitude']},
          [{quantity:0}],
          `${upCopy[idx]['courierCompany']}_${upCopy[idx]['courierType']}`
      );

      if (!res.success) {
        alert(res.error);
        return
      }
      upCopy[idx]['price'] = res.pricing[0].price;
    }

    upCopy[idx]['originLocation'] = a;
    upCopy[idx]['originLatitude'] = c.latitude;
    upCopy[idx]['originLongitude'] = c.longitude;
    upCopy[idx]['originPostalCode'] = p;
    upCopy[idx]['originMap'] = 'filled';
    upCopy[idx]['loading'] = false;

    setUploadOrders(prev => ([...upCopy]));
    setOrder({...order,loading:false})
  };

  const onSelectLocationDestination = async (idx,a,c,p) => {
    let upCopy = uploadOrders;
    if (upCopy[idx]['originLatitude'] && upCopy[idx]['originLongitude']) {
      upCopy[idx]['loading'] = true;
      setUploadOrders(prev => ([...upCopy]));
      let res = await getLogisticPricing (
          token,
          {latitude:upCopy[idx]['originLatitude'], longitude:upCopy[idx]['originLongitude']},
          c,
          [{quantity:0}],
          `${upCopy[idx]['courierCompany']}_${upCopy[idx]['courierType']}`
      );

      if (!res.success) {
        alert(res.error);
        return
      }
      upCopy[idx]['price'] = res.pricing[0].price;
    }
    upCopy[idx]['receiverLatitude'] = c.latitude;
    upCopy[idx]['receiverLongitude'] = c.longitude;
    upCopy[idx]['receiverLocation'] = a;
    upCopy[idx]['receiverPostalCode'] = p;
    upCopy[idx]['receiverMap'] = 'filled';  
    upCopy[idx]['loading'] = false;

    setUploadOrders(prev => ([...upCopy]));
  };


  const onRemoveOrder = (idx) => {
    let upCopy = uploadOrders;
    upCopy.splice(idx, 1);
    setUploadOrders(upCopy);
    setOrder({...order,loading:false})
  };

  const onRemoveStoreOrder = (idx) => {
    let upCopy = uploadStoreOrders;
    upCopy.splice(idx, 1);
    setUploadStoreOrders(upCopy);
    setOrder({...order,loading:false})
  }

  const shippingTypeChange = e => {
    let newValues;
    if( e === 'freight') {
      newValues = {...order,
        serviceType: 'standard',
        shippingType:e,
        courierOptionFiltered: order.courierOption.filter(i => i.shippingType === e)}
    } else {
      newValues = {...order,
        shippingType:e,
        courierOptionFiltered: order.courierOption.filter(i =>
            i.shippingType === e && i.serviceType === 'standard')
      }
    }
    setOrder(newValues)
  };

  const serviceTypeChange = e => {
    setOrder({...order,
      serviceType:e,
      courierOptionFiltered: order.courierOption.filter(i =>
          i.serviceType === e && i.shippingType !== 'freight'
      )
    })
  };


  const onDownloadFile = async (type) => {
    let url,name;
    if (type === 'orders') {
      url = `${API}/v1/files/orders`;
      name = `Biteship Order Template`
    } else {
      url = `${API}/v1/files/couriers`;
      name = `Biteship Courier List`
    }
    const res = await fetch(url,{
      mode: 'cors',
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    });
    const blob = await res.blob();
    download(blob, name);
  }

  const courierParcelNav = () => {
    const pa = order.courierInstant;
    const sa = order.courierSameDay;
    const on = order.courierOvernight;
    const st = order.courierStandard;

    if (pa > 0 && sa === 0 && on === 0 && st === 0) {
      return false
    } else if (pa === 0 && sa > 0 && on === 0 && st === 0) {
      return false
    } else if (pa === 0 && sa === 0 && on > 0 && st === 0) {
      return false
    } else if (pa === 0 && sa === 0 && on === 0 && st > 0) {
      return false
    } else {
      return true
    }
  };

  const onChangeCOD = e => {
    const value = e.target.value;
    if (value > 10000000) {
      return alert("Mohon maaf. Nilai COD yang ditagihkan tidak dapat lebih dari Rp 10.000.000")
    }
    setOrder({
      ...order,
      error:false,
      success:false,
      receiverCashOnDeliveryAmount: value
    });
  };
  
  const courierAdditionalFeature = () => {
    let codFeature,podFeature,insuranceFeature;
    if (podCouriers(order.courierCompany)) {
      let podFee = podCourierRates(order.courierCompany)
      podFeature = (
        <div>
          <div className="my-2 input-group input-group-sm">
            <input
                type="text"
                className="form-control"
                placeholder="Catatan untuk bukti surat jalan"
                onChange={onChange('receiverProofOfDeliveryNote')}
                value={order.receiverProofOfDeliveryNote}
                disabled={!order.receiverProofOfDelivery}
                required
            >
            </input>
            <div className="input-group-append">
              <button
                  onClick={onClickProofOfDelivery}
                  className="btn btn-outline-primary"
                  type="button"
              >
                {order.receiverProofOfDelivery ? "Tidak Pakai" : "Pakai Surat Jalan" }
              </button>
            </div>
          </div>
          {
            order.receiverProofOfDelivery && podFee > 0 ? 
            <p>Biaya Layanan <b>Rp {numeral(podFee).format("0,0")}</b></p> : null
          }
          <div>
            
          </div>
        </div>
      )
    } 
    
    if (codCouriers(order.courierCompany)) {
      let buttonTitle;
      let addFee = 0;
      switch (order.receiverCashOnDeliveryType) {
        case '7_days':
          buttonTitle = 'Cair dalam 7 Hari';
          break;
        case '5_days':
          buttonTitle = 'Cair dalam 5 Hari';
          addFee = 1;
          break;
        case '3_days':
          buttonTitle = 'Cair dalam 3 Hari';
          addFee = 2;
          break;
        default:
          buttonTitle = "Aktifkan COD"
          break;
      }

      const selectedCODCourier = user.cashOnDelivery.filter(i => i.courierCode === order.courierCompany);;
      if (selectedCODCourier.length === 0) { 
        codFeature = null;
      } else {
        codFeature = (
          <div>
              <InputGroup className="my-2 input-group-sm">
                <FormControl 
                  aria-label="Text input with dropdown button" 
                  placeholder="Masukkan nilai barang yang akan ditagih"
                  onChange={onChange('receiverCashOnDeliveryAmount')}
                  value={order.receiverCashOnDeliveryAmount}
                  disabled={!order.receiverCashOnDelivery}
                />
  
                <DropdownButton
                  variant="sm outline-primary btn-outline-primary btn-cod"
                  style={{borderTopLeftRadius:0,borderBottomLeftRadius:0}}
                  title={buttonTitle}
                  id="input-group-dropdown-2"
                  align="end"
                >
                  <Dropdown.Item onClick={() => onClickCashOnDelivery(false)}>Non-Aktifkan COD</Dropdown.Item>
                  <Dropdown.Item onClick={() => onClickCashOnDelivery(true,"7_days")}>COD Cair dalam 7+ hari</Dropdown.Item>
                  <Dropdown.Item onClick={() => onClickCashOnDelivery(true,"5_days")}>COD Cair dalam 5 hari</Dropdown.Item>
                  <Dropdown.Item onClick={() => onClickCashOnDelivery(true,"3_days")}>COD Cair dalam 3 hari</Dropdown.Item>
                </DropdownButton>
              </InputGroup>
  
            {
              order.receiverCashOnDelivery ? 
                <p>Biaya Layanan ({selectedCODCourier[0].fee+addFee}% dari harga ditagihkan) <b>Rp. {numeral((selectedCODCourier[0].fee+addFee)/100*order.receiverCashOnDeliveryAmount < 2000 ?  2000 : (selectedCODCourier[0].fee+addFee)/100*order.receiverCashOnDeliveryAmount ).format("0,0")}</b></p> : null
            }
          </div>
        )
      }
      
    }

    if (insuranceCouriers(order.courierCompany)) {
      const selectedInsurance = user.insurances.filter(i => i.type === 'basic');
      const insuranceValue = selectedInsurance[0].value*order.courierInsuranceAmount;
      insuranceFeature = (
        <div>
          <div className="my-2 input-group input-group-sm">
            <input
                type="text"
                className="form-control"
                placeholder="Nilai Asuransi Berdasarkan Harga Barang"
                value={order.courierInsurance ? order.courierInsuranceAmount : ""}
                disabled={!order.courierInsurance}
                required
            >
            </input>
            <div className="input-group-append">
              <button
                  onClick={onClickInsurance}
                  className="btn btn-outline-primary"
                  type="button"
              >
                {order.courierInsurance ? "Non-Aktifkan Asuransi" : "Pakai Asuransi" }
              </button>
            </div>
          </div>
          {
          order.courierInsurance ? 
            <p>Biaya Layanan ({selectedInsurance[0].value*100}% dari harga barang) <b>Rp. {numeral(insuranceValue).format("0,0")}</b></p> : null
          }
        </div>
        
      )
    }

    if (podCouriers(order.courierCompany) || codCouriers(order.courierCompany) || insuranceCouriers(order.courierCompany)) {
      return (
        <div>
            <div className={`mt-2`}><strong>Fitur Tambahan</strong></div>
            {codFeature}
            {podFeature}
            {insuranceFeature}
            <ExtraFeatures 
              courier={order.courierCompany} 
              service={order.courierType}
              onChange={e => onChangeExtra(e)}
            />
            <hr className="mb-3"/>
        </div>
      )
    }
  };

  const deliveryTypeNav = () => {
    return (
      <div className="row mr-0">
        <div className="col-12 pt-2 pr-0 border-right address-window">
          <Nav
              variant="tabs"
              defaultActiveKey="/home"
              onSelect={deliveryTypeChange}>
            {
              courierWithInstantPickup(order.courierCompany) ?
                  <Nav.Item className="ml-4">
                    <Nav.Link eventKey="now" active={tab === 'now'}>
                      Langsung Kirim
                    </Nav.Link>
                  </Nav.Item> : ''
            }
            <Nav.Item className={`${!courierWithInstantPickup(order.courierCompany) ? 'ml-4' : ''}`}>
              <Nav.Link eventKey="later" active={tab === 'later'}>
                Simpan Pengiriman
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="many" active={tab === 'many'}>
                Pengiriman Banyak
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="upload" active={tab === 'upload'}>
                Upload Pengiriman
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="webstore" active={tab === 'webstore'}>
                Import Pesanan Toko
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
      </div>
    )
  };

  const bodyForm = () => {
    if (tab === 'many') {
      return bulkOrderForm()
    } else if (tab === 'upload') {
      return uploadOrdersForm()
    } else if (tab === 'webstore') {
      return webstoreForm()
    } else {
      return singleAndScheduledOrderForm()
    }
  };

  const uploadOrdersForm = () => {
    if (uploadOrders.length === 0 && !uploadLoading) {
      return (
          <div className="col-12 py-4 center">
            <div ref={ref}>
              <Dropzone onFileDrop={onOrderFileDrop}/>
              <br/>
              <p className="text-center">Unduh format pemesanan Excel Anda.
                <a className="text-primary pointer" onClick={() => onDownloadFile('orders')}>
                  <b><u> Klik Disini untuk Download</u></b>
                </a>
              </p>
              <p className="text-center">List kurir tersedia dapat download
                <a className="text-primary pointer" onClick={() => onDownloadFile('couriers')}>
                  <b><u> di sini</u></b>
                </a>
              </p>
            </div>
          </div>
      )
    }

    if (uploadLoading) {
      return (
        <div className="text-center row">
          <div ref={ref} className="col-3"/>
          <div className="row col-5 py-5">
            <ReactLoading
                type={'bubbles'}
                color={'#459BD8'}
                height={54}
                width={75}
            />
            <h5 className="mt-4 "><strong> File anda sedang diupload...</strong></h5>
          </div>
          <div className="col-4"/>
        </div>
      )
    }

    return (
        <div>
          <div ref={ref}>
            <UploadOrderTable
                data={uploadOrders}
                onRemoveOrder={onRemoveOrder}
                onPressOriginMap={onPressOriginMap}
                onPressDestinationMap={onPressDestinationMap}
                onChangeLocationOrigin={onChangeLocationOrigin}
                onSelectLocationOrigin={onSelectLocationOrigin}
                onChangeLocationDestination={onChangeLocationDestination}
                onSelectLocationDestination={onSelectLocationDestination}
            />
          </div>
        </div>
    )
  };

  const bulkOrderForm = () => {
    return (
        <div className="col-12 pt-2 pr-0 border-right address-window">
          <div ref={ref}>
            <div className="px-4 pb-4 pt-2">
              <div className="my-2 row mx-0 justify-content-between">
                <div>
                  <span className="text-primary">
                    <i className="fas fa-map-marker-alt mr-2"/>
                  </span>
                  <strong>Asal Pengiriman</strong>
                </div>
                <div>
                  <a
                      onClick={order.originLocation ? () => openMap('origin') : ''}
                      className={`${order.originLocation ? 'text-info' : 'text-muted'} pointer`}>
                    <u><b>Lihat Peta</b></u>
                  </a>
                </div>
              </div>

              {formRow(
                  {
                    name:order.originName,
                    phone:order.originPhone,
                    location:order.originLocation,
                    postalCode:order.originPostalCode,
                    note:order.originNote
                  },
                  onChange,
                  onSelectOriginLocation,
                  onOriginChange,
                  onSelectOrigin
              )}

              <hr/>

              <div className="mb-2 row mx-0 justify-content-between">
                <div>
                  <span className="text-danger">
                    <i className="fas fa-map-marker-alt mr-2"/>
                  </span>
                  <strong>Destinasi Pengiriman</strong>
                </div>
              </div>

              {
                destinations.map((item,idx) => {
                  return (
                    <div>
                      {formRow(item,
                          onDestinationsValueChange,
                          setDestinationsLocation,
                          onDestinationsChange,
                          onSelectDestinationsFromAddress,
                          onSelectDestinationsCourier,
                          onSelectDestinationsDateTime,
                          onSelectDestinationsItem,
                          idx,
                          'destination'
                      )}
                      <hr className="mt-1 mb-3"/>
                    </div>
                  )
                })
              }
              {
                destinations.length === 10 ? null :
                    <button
                        onClick={() => onAddDestination()}
                        className="mb-2 bg-lighter btn btn-block btn-sm">
                      Tambah Pengiriman Lainnya
                    </button>
              }
            </div>
          </div>
        </div>
    )
  };

  const formRow = (
      values,
      onChange,
      setLocation,
      onLocationChange,
      onSelectLocation,
      onSelectCourier,
      onSelectDateTime,
      onSelectItem,
      idx,
      type
  ) => {
    if (values.loading) {
      return (
          <div className="align-items-center d-block text-center py-4">
            <b>Menghitung Ongkos Kirim...</b>
          </div>
      )
    }
    if (type === 'destination') {
      return (
          <div className="row">
            <div className={`mb-3 ${destinations.length === 1 ? "col-12" : "col-11" }`}>
              <div className="form-row mb-2">
                <div className="col-md-2 input-group-sm">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="Nama penerima"
                      onChange={onChange('name',idx)}
                      value={values.name}
                      required
                  />
                </div>
                <div className="col-md-2 input-group-sm">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="No HP Penerima"
                      onChange={onChange('phone',idx)}
                      value={values.phone}
                      required
                  />
                </div>
                <div className="col-md-3 input-group-sm">
                  <DatePicker
                      className={"form-control display-block"}
                      calendarClassName={"row p-0 "}
                      selected={values.deliveryDateTime}
                      onChange={date => onSelectDateTime(date,idx)}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      timeCaption="time"
                      dateFormat="MMMM d, yyyy h:mm aa"
                  />
                </div>
                <div className="col-md-2 input-group-sm">
                  <select
                      id="inputState"
                      className="form-control"
                      onChange={e => onSelectItem('name',e,idx)}
                      value={values.items[0].name}
                  >
                    {
                      itemOptions.map((i,idx) => (
                          <option
                              key={idx}
                              value={i}
                              className={`${idx === 0 ? "selected":""}`}
                          >
                            {i}
                          </option>
                      ))
                    }
                  </select>
                </div>
                <div className="col-md-2 input-group-sm">
                  <select
                      id="inputState"
                      className="form-control"
                      onChange={e => onSelectItem('weight',e,idx)}
                      value={values.items[0].weight}
                  >
                    {
                      weightOptions.map((i,idx) => (
                          <option
                              key={idx}
                              value={i}
                              className={`${idx === 0 ? "selected":""}`}
                          >
                            {i/1000} Kg
                          </option>
                      ))
                    }
                  </select>
                </div>

                <Dropdown className="col-md-1 btn-group btn-group-sm">
                  <Dropdown.Toggle
                      id="dropdown-basic"
                      className="btn btn-block btn-secondary border border-grey btn-sm dropdown-toggle">
                    Pilih
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu-scroll" style={{
                    height:`${addresses.length > 6 ? "200" :
                        addresses.length === 0 ? "40" :
                            addresses.length*33  }px`}}>
                    {
                      addresses.length === 0 ?
                          <Dropdown.Item className="text-info text-" onClick={() => window.open(`/address`)}><strong>+ Tambah Alamat</strong></Dropdown.Item>
                          :
                          addresses.map((i,x) => (
                              <Dropdown.Item key={x} onClick={() => onSelectLocation(i,idx)}>{i.addressName}</Dropdown.Item>
                          ))
                    }
                  </Dropdown.Menu>
                </Dropdown>

              </div>
              <div className="form-row">
                <div className="col-md-4 input-group-sm">
                  <InputLocation
                      setLocation={(a,c,id,pc) => setLocation(a,c,pc,idx)}
                      placeholder={'Masukkan lokasi penerima'}
                      onLocationChange={e => onLocationChange(e,idx)}
                      value={values.location}
                      loading={values.loading}
                  />
                </div>
                <div className="col-md-1 input-group-sm">
                  <input
                      placeholder={'Kodepos'}
                      className="form-control pr-1 bg-white"
                      disabled
                      value={values.postalCode}
                  />
                </div>
                <div className="col-md-3 input-group-sm">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="Catatan / Alamat penerima"
                      onChange={onChange('note',idx)}
                      value={values.note}
                      required
                  />
                </div>
                <div className="col-md-4 input-group-sm">
                  { values.courierOptions.length === 0 ?
                      <input
                          type="text"
                          className="form-control"
                          placeholder={values.loading || "Isi Destinasi Untuk Cek Ongkir"}
                          disabled
                      />
                      :
                      <select
                          id="inputState"
                          className="form-control"
                          onChange={e => onSelectCourier(e,idx)}
                          value={JSON.stringify({
                            courierCompanyName: values.courierCompanyName,
                            courierCompanyCode: values.courierCompanyCode,
                            courierTypeName: values.courierTypeName,
                            courierTypeCode: values.courierTypeCode,
                            price: values.price
                          })}
                      >
                        {
                          values.courierOptions.map((i,idx) => (
                              <option
                                  key={idx}
                                  value={JSON.stringify({
                                    courierCompanyName: i.courierName,
                                    courierCompanyCode: i.courierCode,
                                    courierTypeName: i.courierServiceName,
                                    courierTypeCode: i.courierServiceCode,
                                    price: i.price
                                  })}
                                  className={`${idx === 0 ? "selected":""}`}
                              >
                                {i.courierName} - {i.courierServiceName} ({i.duration}) - Rp. {numeral(i.price).format("0,0")}
                              </option>
                          ))
                        }
                      </select>
                  }
                </div>

              </div>
            </div>
            {
              destinations.length === 1 ? null :
                  <div className="col-1">
                    <div className="pointer pt-3">
                      <ReactTooltip/>
                      <a onClick={() => onRemoveDestination(idx)}
                         className="action-item ml-2 text-center"
                         data-tip="Hapus pengiriman ini"
                         title="Trash">
                        <i className="fas fa-trash"></i><br/>
                        <small>HAPUS</small>
                      </a>
                    </div>
                  </div>
            }
          </div>

      )
    }

    return (
        <div className="form-row">
          <div className="col-md-2 input-group-sm">
            <input
                type="text"
                className="form-control"
                placeholder="Nama pengirim"
                onChange={onChange('name',idx)}
                value={values.name}
                required
            />
          </div>
          <div className="col-md-2 input-group-sm">
            <input
                type="text"
                className="form-control"
                placeholder="No telpon/HP pengirim"
                onChange={onChange('phone',idx)}
                value={values.phone}
                required
            />
          </div>
          <div className="col-md-4 input-group-sm">
            <InputLocation
                setLocation={(a,c,id,pc) => setLocation(a,c,pc,idx)}
                placeholder={'Masukkan titik penjemputan'}
                onLocationChange={onLocationChange}
                value={values.location}
                loading={values.loading}
            />
          </div>
          <div className="col-md-1 input-group-sm">
            <input
                placeholder={'Kodepos'}
                className="form-control pr-1 bg-white"
                disabled
                value={values.postalCode}
            />
          </div>
          <div className="col-md-2 input-group-sm">
            <input
                type="text"
                className="form-control"
                placeholder="Alamat lengkap penerima. Seperti nomor rumah atau patokan lokasi."
                onChange={onChange('note',idx)}
                value={values.note}
                required
            />
          </div>
          <Dropdown className="col-md-1 btn-group btn-group-sm">
            <Dropdown.Toggle
                id="dropdown-basic"
                className="btn btn-block btn-secondary border border-grey btn-sm dropdown-toggle">
              Pilih
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-menu-scroll" style={{
              height:`${addresses.length > 6 ? "200" :
                  addresses.length === 0 ? "40" :
                      addresses.length*33  }px`}}>
              {
                addresses.length === 0 ?
                    <Dropdown.Item className="text-info text-" onClick={() => window.open(`/address`)}><strong>+ Tambah Alamat</strong></Dropdown.Item>
                    :
                    addresses.map((i,idx) => (
                        <Dropdown.Item key={idx} onClick={() => onSelectLocation(i,idx)}>{i.addressName}</Dropdown.Item>
                    ))
              }
            </Dropdown.Menu>
          </Dropdown>
        </div>
    )
  };

  const singleAndScheduledOrderForm = () => {
    let scheduledOrderView;
    if (order.deliveryType === 'later') {
      scheduledOrderView = (
          <div className="ml-1">
            {
              courierWithMultipleItems(order.courierCompany) ?
                  <div className="my-2"><strong>Pilih Waktu Penjemputan Barang</strong></div> :
                  <div className="my-2"><strong>Perkiraan Akan Dikirim</strong></div>
            }
            <div className="form-row">
              <DatePicker
                  className="form-control col-md-12 mb-0"
                  onChange={setDate}
                  selected={order.deliveryDate}
              />
              <div className="form-group col-md-7 input-group-sm mb-0">
                {
                  allDayPickupCourier(order.courierCompany) ?
                      <TimePicker
                          onChange={setTime}
                          value={order.deliveryTime}
                          format={24}
                      />
                      :
                      <select
                          className="form-control"
                          onChange={setTime}
                      >
                        {
                          pickupTime.map((i,idx) => (
                              <option
                                  key={idx}
                                  value={i}
                                  className={`${idx === 0 ? "selected":""}`}
                              >
                                {i}
                              </option>
                          ))
                        }
                      </select>
                }

              </div>
            </div>
            {
              !courierWithMultipleItems(order.courierCompany) ? "" :
                  <i><small>Interval penjemputan barang ± 30-60 menit dari waktu yang dipilih</small></i>
            }
             <hr className="mt-4 mb-3"/>
          </div>
      )
    } 


    return (
      <div className="row mr-0">
        <div className="col-7 pt-2 pr-0 border-right address-window">
          <div ref={ref}>
            <div className="px-4 pb-4 pt-2">
              <div className="my-2 row mx-0 justify-content-between">
                <div>
                  <span className="text-primary">
                    <i className="fas fa-map-marker-alt mr-2"/>
                  </span>
                  <strong>Asal Pengiriman</strong>
                </div>
                <div>
                  <a
                      onClick={order.originLocation ? () => openMap('origin') : ''}
                      className={`${order.originLocation ? 'text-info' : 'text-muted'} pointer`}>
                    <u><b>Lihat Peta</b></u>
                  </a>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-5 input-group-sm">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="Nama pengirim"
                      onChange={onChange('originName')}
                      value={order.originName}
                      required
                  />
                </div>
                <div className="col-md-5 input-group-sm">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="No telpon/HP pengirim"
                      onChange={onChange('originPhone')}
                      value={order.originPhone}
                      required
                  />
                </div>
                <Dropdown className="col-md-2 btn-group">
                  <Dropdown.Toggle
                      id="dropdown-basic"
                      className="btn btn-block btn-secondary border border-grey btn-sm dropdown-toggle">
                    Pilih
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu-scroll" style={{
                    height:`${addresses.length > 6 ? "200" :
                        addresses.length === 0 ? "40" :
                            addresses.length*33  }px`}}>
                    {
                      addresses.length === 0 ?
                          <Dropdown.Item className="text-info text-" onClick={() => window.open(`/address`)}><strong>+ Tambah Alamat</strong></Dropdown.Item>
                          :
                          addresses.map((i,idx) => (
                              <Dropdown.Item key={idx} onClick={() => onSelectOrigin(i)}>{i.addressName}</Dropdown.Item>
                          ))
                    }
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <div className="form-row mt-2">
                <div className="col-md-10 input-group-sm">
                  <InputLocation
                      setLocation={setOriginLocation}
                      placeholder={'Masukkan titik penjemputan'}
                      onLocationChange={onOriginChange}
                      value={order.originLocation}
                      loading={loadings.origin}
                  />
                </div>
                <div className="col-md-2 input-group-sm">
                  <input
                      placeholder={'Kodepos'}
                      className="form-control pr-1 bg-white"
                      disabled
                      value={order.originPostalCode}
                  />
                </div>
              </div>

              <div className="form-row mt-2">
                <div className="col-md-12 input-group-sm">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="Alamat lengkap pengirim. Seperti nomor rumah atau patokan lokasi."
                      onChange={onChange('originNote')}
                      value={order.originNote}
                      required
                  />
                </div>
              </div>
              <hr className="mt-4 mb-3"/>
              <div className="mb-2 row mx-0 justify-content-between">
                <div>
                  <span className="text-danger">
                    <i className="fas fa-map-marker-alt mr-2"/>
                  </span>
                  <strong>Destinasi Pengiriman</strong>
                </div>
                <div>
                  <a
                      onClick={order.receiverLocation ? () => openMap('destination') : ''}
                      className={`${order.receiverLocation ? 'text-info' : 'text-muted'} pointer`}>
                    <u><b>Lihat Peta</b></u>
                  </a>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-5 input-group-sm">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="Nama penerima"
                      onChange={onChange('receiverName')}
                      value={order.receiverName}
                      required
                  />
                </div>
                <div className="col-md-5 input-group-sm">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="No telpon/HP penerima"
                      onChange={onChange('receiverPhone')}
                      value={order.receiverPhone}
                      required
                  />
                </div>

                <Dropdown className="col-md-2 btn-group">
                  <Dropdown.Toggle
                      id="dropdown-basic"
                      className="btn btn-block btn-secondary border border-grey btn-sm dropdown-toggle">
                    Pilih
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu-scroll" style={{height:`200px`}}>
                    {
                      addresses.length === 0 ?
                          <Dropdown.Item className="text-info strong" onClick={() => window.open(`/address`)}><strong>+ Tambah Alamat</strong></Dropdown.Item>
                          : addresses.map((i,idx) => (
                              <Dropdown.Item key={idx} onClick={() => onSelectDestination(i)}>{i.addressName}</Dropdown.Item>
                          ))
                    }
                  </Dropdown.Menu>
                </Dropdown>


              </div>

              <div className="form-row mt-2">
                <div className="col-md-10 input-group-sm">
                  <div/>
                  <InputLocation
                      setLocation={setDestinationLocation}
                      placeholder={'Masukkan titik destinasi'}
                      onLocationChange={onDestinationChange}
                      value={order.receiverLocation}
                      loading={loadings.destination}
                  />
                </div>
                <div className="col-md-2 input-group-sm">
                  <input
                      placeholder={'Kodepos'}
                      className="form-control pr-1 bg-white"
                      disabled
                      value={order.receiverPostalCode}
                  />
                </div>
              </div>
              <div className="form-row mt-2">
                <div className="col-md-12 input-group-sm">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="Alamat lengkap penerima. Seperti nomor rumah atau patokan lokasi."
                      onChange={onChange('receiverNote')}
                      value={order.receiverNote}
                      required
                  />
                </div>
              </div>

              <hr className="mt-4 mb-3"/>

              { courierAdditionalFeature() }

              { scheduledOrderView }

              <div className={`mt-2`}><strong>Informasi Barang</strong></div>

              <div>
                {
                  order.orderItems.map((i,idx) => (
                      <div key={idx} className="form-group">
                        <small className="my-1"><strong>Barang {idx+1} </strong></small>
                        <div className="form-row">
                          <div className={`input-group-sm ${isUserFulfillment ? "col-4" :"col-6"}`}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nama Barang / Deskripsi"
                                onChange={handleItemChange(idx,'name')}
                                value={order.orderItems[idx].name}
                                required
                            />
                          </div>
                          {
                            !isUserFulfillment ? null :
                              <div className={`input-group-sm col-3`}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="SKU Barang"
                                    onChange={handleItemChange(idx,'sku')}
                                    value={order.orderItems[idx].sku}
                                    required
                                />
                              </div>
                          }
                         
                          <div className={`input-group-sm ${isUserFulfillment ? "col-3" :"col-4"}`}>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Harga Barang"
                                onChange={handleItemChange(idx,'value')}
                                value={order.orderItems[idx].value === 0 ? '' :
                                    order.orderItems[idx].value
                                }
                                required
                            />
                          </div>
                          <div className={`input-group-sm col-2`}>
                          <Dropdown className="btn-group btn-group-sm">
                            <Dropdown.Toggle
                                id="dropdown-basic"
                                className="btn btn-block btn-secondary border border-grey btn-sm dropdown-toggle">
                              Pilih
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="dropdown-menu-scroll" style={{height:"200"}}>
                              {
                                fullItemOptions.map((i,x) => (
                                    <Dropdown.Item key={x} onClick={() => onSelectItem(i,idx)}>{i.name}</Dropdown.Item>
                                ))
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                          </div>
                        </div>
                        <div className="form-row mt-2">
                          <div className={`input-group-sm col-2`}>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Panjang"
                                onChange={handleItemChange(idx,'length')}
                                value={order.orderItems[idx].length === 0 ? '' :
                                    order.orderItems[idx].length
                                }
                                required
                            />
                          </div>
                          <div className={`input-group-sm col-2`}>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Lebar"
                                onChange={handleItemChange(idx,'width')}
                                value={order.orderItems[idx].width === 0 ? '' :
                                    order.orderItems[idx].width
                                }
                                required
                            />
                          </div>
                          <div className={`input-group-sm col-2`}>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Tinggi"
                                onChange={handleItemChange(idx,'height')}
                                value={order.orderItems[idx].height === 0 ? '' :
                                    order.orderItems[idx].height
                                }
                                required
                            />
                          </div>
                          <div className={`input-group input-group-sm col-md-4`}>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Berat Barang (gram)"
                                onChange={handleItemChange(idx,'weight')}
                                value={order.orderItems[idx].weight}
                                aria-describedby="weight-addon"
                                required
                            />
                            <div className="input-group-append">
                              <span className="input-group-text px-1" id="weight-addon">Gram/qty</span>
                            </div>
                          </div>
                          <div className={`input-group-sm col-2`}>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Jumlah"
                                onChange={handleItemChange(idx,'quantity')}
                                value={order.orderItems[idx].quantity === 0 ? '' :
                                    order.orderItems[idx].quantity
                                }
                                required
                            />
                          </div>
                        </div>
                      </div>
                  ))
                }
                <div className="my-2">
                  <div style={{display: `flex`, justifyContent: `flex-end`}}>
                    {
                      order.orderItems.length > 1 ?
                          <button
                              className="btn btn-secondary col-4 btn-sm"
                              onClick={removeItem}
                          >
                            Kurangi Barang
                          </button> : ''
                    }
                    {
                      order.orderItems.length === 5 ? '' :
                          <button
                              className="btn btn-primary col-4 btn-sm"
                              onClick={onAddItem}
                          >
                            Tambah Barang
                          </button>
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-5 pt-2 px-0 bg-lighter courier-window">
          <h6 className="pl-3">Opsi Pengiriman Kurir</h6>
          { order.courierOption.length === 0 || order.courierLoading ?
              <div className="courier-empty-center form-group">
                {
                  order.courierLoading ?
                      <div className="align-items-center pl-3">
                        <ReactLoading
                            type={'bubbles'}
                            color={'#459BD8'}
                            height={36}
                            width={36}
                        />
                        <b>Mencari Kurir...</b>
                      </div>
                      :
                      <div className="pl-3">
                        {
                          (order.weight || order.volume) && order.receiverLocation ?
                              <div>
                                Total Berat<strong> {
                                order.weight ? order.weight : 0
                              } gram</strong><br/>
                                Total Volume<strong> {
                                order.volume ? order.volume : 0
                              } cm2</strong>
                                <br/>
                                <br/>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => checkCourier()}
                                >
                                  Cek Harga Kurir
                                </button>
                              </div>
                              :
                              <div className="pr-2">
                                {
                                  order.receiverPostalCode && order.originLocation ?
                                      "Masukan alamat asal, tujuan dan detail barang untuk cek harga kurir 😄" :
                                      "Tentukan destinasi dan tujuan terlebih dahulu ya 😄"
                                }
                              </div>
                        }
                      </div>
                }
              </div>
              :
              <div>
                <div className="form-group mb-0 courier-option-section" style={{height}}>
                  <div className="px-3">
                    {
                      (order.courierParcel > 0 && order.courierFreight === 0 )||
                      (order.courierParcel === 0 && order.courierFreight > 0 ) ?
                          null :
                          <Nav
                              fill
                              className="no-padding"
                              variant="pills"
                              defaultActiveKey="/home"
                              onSelect={shippingTypeChange}>
                            {
                              order.courierParcel > 0 ?
                                  <Nav.Item>
                                    <Nav.Link className="py-1" eventKey="parcel" active={order.shippingType === 'parcel'}>
                                      Paket
                                    </Nav.Link>
                                  </Nav.Item>
                                  : null
                            }
                            {
                              order.courierFreight > 0 ?
                                  <Nav.Item>
                                    <Nav.Link className="py-1" eventKey="freight" active={order.shippingType === 'freight'}>
                                      Kargo
                                    </Nav.Link>
                                  </Nav.Item>
                                  : null
                            }
                          </Nav>
                    }

                    {
                      order.shippingType === 'parcel' && courierParcelNav() ?
                          <Nav
                              fill
                              className="no-padding"
                              variant="pills"
                              defaultActiveKey="/home"
                              onSelect={serviceTypeChange}>
                            {
                              order.courierInstant > 0 ?
                                  <Nav.Item>
                                    <Nav.Link className="py-1" eventKey="instant" active={order.serviceType === 'instant'}>
                                      Instant
                                    </Nav.Link>
                                  </Nav.Item>
                                  : null
                            }
                            {
                              order.courierSameDay > 0 ?
                                  <Nav.Item>
                                    <Nav.Link className="py-1" eventKey="sameDay" active={order.serviceType === 'sameDay'}>
                                      Same Day
                                    </Nav.Link>
                                  </Nav.Item>
                                  : null
                            }
                            {
                              order.courierOvernight > 0 ?
                                  <Nav.Item>
                                    <Nav.Link className="py-1" eventKey="overnight" active={order.serviceType === 'overnight'}>
                                      Next Day
                                    </Nav.Link>
                                  </Nav.Item>
                                  : null
                            }
                            {
                              order.courierStandard > 0 ?
                                  <Nav.Item>
                                    <Nav.Link className="py-1" eventKey="standard" active={order.serviceType === 'standard'}>
                                      Standard
                                    </Nav.Link>
                                  </Nav.Item>
                                  : null
                            }
                          </Nav> : ""
                    }
                  </div>

                  {
                    !courierFilter ? null :
                        <div className="mb-2">
                          <p className="m-0">Filter</p>
                          <div className="form-row">
                            <div className="col">
                              <select className="custom-select custom-select-sm">
                                <option selected>Urutkan Durasi</option>
                                <option value="1">One</option>
                              </select>
                            </div>
                            <div className="col">
                              <select className="custom-select custom-select-sm">
                                <option selected>Urutkan Harga</option>
                                <option value="1">One</option>
                              </select>
                            </div>
                          </div>
                        </div>
                  }
                  {
                    order.courierOptionFiltered.map((i,idx) => {
                      return (
                          <div key={idx} className="px-3">
                            <div
                                className={
                                  `col-12 py-1 rounded mb-2 courier-option d-flex justify-content-between
                            ${idx === 0 ? "mt-2" : ""} 
                            ${order.courierCompany === i.company && order.courierType === i.type ?
                                      "courier-selected" : ""
                                  }`
                                }
                                onClick={() => selectCourier(i)}
                            >
                              <div>
                                <b>{normalizeCourierServices(i.company,i.type).companyName}</b><br/>
                                <small><i>{normalizeCourierServices(i.company,i.type).typeView}</i> - {i.description}</small>
                              </div>
                              <div className="text-right">
                                <b className={`text-success text-right`}>
                                  Rp. {numeral(i.price).format("0,0")}
                                </b>
                                <br/>
                                <p className="m-0 text-right">
                                  <small>{i.duration}</small>
                                </p>
                              </div>
                            </div>
                          </div>
                      )
                    })
                  }
                  <div className="pl-3">
                    {
                      order.courierOptionFiltered.length === 0 ?
                          <div className="mt-3">
                            <p>Kurir dengan rute dan layanan ini belum tersedia :)</p>
                          </div>
                          : null
                    }
                  </div>
                </div>
              </div>
          }
        </div>
      </div>
    )
  };

  const webstoreForm = () => {
    if (uploadStoreOrders.length === 0 && !uploadStoreLoading) {
      return (
        <div className="col-12 py-4 center">
          <div ref={ref}>
            <div className="card py-4 px-5">
                <div className="row d-flex justify-content-between">
                    <img 
                        style={{height:36, marginLeft:8}} 
                        src={`/images/landing/shopify-logo.png`} 
                        alt={`Biteship Shopify`}
                    />
                    <div className="input-group-sm col-2">
                        <button 
                            onClick={() => onSyncShopifyOrders()}
                            type="submit" 
                            class="btn btn-sm btn-primary"
                        >
                            Import Pesanan 
                        </button>
                    </div>
                </div>
            </div>
          </div>
        </div>
      )
    }
    
    if (uploadStoreLoading) {
      return (
        <div className="text-center row">
          <div ref={ref} className="col-3"/>
          <div className="row col-5 py-5">
            <ReactLoading
                type={'bubbles'}
                color={'#459BD8'}
                height={54}
                width={75}
            />
            <h5 className="mt-4 "><strong> Order Anda sedang di import...</strong></h5>
          </div>
          <div className="col-4"/>
        </div>
      )
    }

    return (
      <div>
        <div ref={ref}>
          <UploadStoreOrderTable
              data={uploadStoreOrders}
              onRemoveStoreOrder={onRemoveStoreOrder}
          />
        </div>
      </div>
    )
  }

  const modalFooterView = () => {
    let paymentMethod, creditOption;
    if (user.walletType === 'postpaid' || props.admin) {
      creditOption = (
          <option
              value='credit'
              selected={`${order.paymentMethod === 'credit' ? "selected":""}`}
          >
            Credit
          </option>
      )
    }

    if ((order.courierCompany === 'gojek' || order.courierCompany === 'grab') && order.deliveryType !== 'many' && order.deliveryType !== 'upload') {
      paymentMethod = (
          <div className="col-sm-6 mt-1 input-group-sm">
            <select
                id="inputState"
                className="form-control"
                onChange={e => handlePaymentMethod(e)}
            >
              <option
                  value=''
                  selected={`${order.paymentMethod === '' ? "selected":""}`}
              >
                Pilih...
              </option>
              {creditOption}
              <option
                  value='bitepay'
                  selected={`${order.paymentMethod === 'bitepay' ? "selected":""}`}
              >
                Bite Points
              </option>
              <option
                  value='qris'
                  selected={`${order.paymentMethod === 'qris' ? "selected":""}`}
              >
                QR Code
              </option>
            </select>
          </div>
      )
    } else if (order.deliveryType === 'many' || order.deliveryType === 'upload' || order.deliveryType === 'webstore') {
      paymentMethod = (
          <div className="col-sm-4 mt-1 input-group-sm">
            <select
                id="inputState"
                className="form-control"
                onChange={e => handlePaymentMethod(e)}
            >
              <option
                  value=''
                  selected={`${order.paymentMethod === '' ? "selected":""}`}
              >
                Pilih...
              </option>
              {creditOption}
              <option
                  value='bitepay'
                  selected={`${order.paymentMethod === 'bitepay' ? "selected":""}`}
              >
                Bite Points
              </option>
            </select>
          </div>
      )
    } else {
      paymentMethod = (
          <div className="col-sm-6 mt-1 input-group-sm">
            <select
                id="inputState"
                className="form-control"
                onChange={e => handlePaymentMethod(e)}
            >
              <option
                  value=''
                  selected={`${order.paymentMethod === '' ? "selected":""}`}
              >
                Pilih...
              </option>
              {creditOption}
              <option
                  value='bitepay'
                  selected={`${order.paymentMethod === 'bitepay' ? "selected":""}`}
              >
                Bite Points
              </option>
              <option
                  value='qris'
                  selected={`${order.paymentMethod === 'qris' ? "selected":""}`}
              >
                QR Code
              </option>
            </select>
          </div>
      )
    }

    return (
        <div className="row" style={{width:`512px`}}>
          <label className="col-sm-4 mb-1 col-form-label">Tipe Pembayaran</label>
          { paymentMethod }
        </div>
    )
  };

  const showError = () => {
    return (
        <div
            className="alert alert-danger mb-0"
            style={{display: order.error ? '' : 'none'}}
        >
          { order.error }
        </div>
    )
  };

  const showSuccess = () => {
    return (
        <div
            className="alert alert-success mb-0"
            style={{display: order.success ? '' : 'none'}}
        >
          Order berhasil dibuat
        </div>
    )
  };

  const showInfo = () => {
    return (
        <div
            className="alert alert-info mb-0"
            style={{display: order.info ? '' : 'none'}}
        >
          Sedang membuat orderan...
        </div>
    )
  };

  let rbText, rbClassName, courierText, buttonPrice;

  buttonPrice = order.price;
  if (order.receiverProofOfDelivery) {
    buttonPrice += podCourierRates(order.courierCompany)
  } 

  if (order.extra.filter(i => i.name === 'roundtrip').length > 0) {
    buttonPrice += 10000
  }
  
  if (order.receiverCashOnDelivery) {
    let addFee = 0;
    
    switch (order.receiverCashOnDeliveryType) {
      case '7_days':
        addFee = 0;
        break;
      case '5_days':
        addFee = 1;
        break;
      case '3_days':
        addFee = 2;
        break;
      default:
        break;
    }

    let codFee = 0;
    if (codCouriers(order.courierCompany)) {
      const selectedCODCourier = user.cashOnDelivery.filter(i => i.courierCode === order.courierCompany);

      if (selectedCODCourier.length === 0) {
          codFee = 0;
      } else {
        const codUnit = selectedCODCourier[0].feeUnit;
        
        if (codUnit === 'percentage') {
            codFee = parseInt(order.receiverCashOnDeliveryAmount*(selectedCODCourier[0].fee+addFee)/100)
        }            
      }

      if (codFee < 2000) {
        codFee = 2000
      }
    }
    buttonPrice += codFee
  } 

  if (order.courierInsurance) {
    let insuranceValue;
    const selectedInsurance = user.insurances.filter(i => i.type === 'basic');
    if (insuranceCouriers(order.courierCompany)) {
      insuranceValue = selectedInsurance[0].value*order.courierInsuranceAmount;
    }
    buttonPrice += insuranceValue
  } 

  if (!order.courierCompany) {
    courierText = ""
  } else if (order.courierCompany !== "-" && order.deliveryType !== 'many' && order.deliveryType !== 'upload') {
    courierText = `- ${normalizeCourierServices(order.courierCompany,order.courierType).companyName} - Rp. ${numeral(buttonPrice).format("0,0")}`
  } else if (order.deliveryType === 'many') {
    courierText = `- ${destinations.length} Pesanan - Rp. ${numeral(buttonPrice).format("0,0")}`;
  } else if (order.deliveryType === 'upload') {
    let uploadTotalPrice = uploadOrders.reduce((r,i) => {
      return r += i.price
    },0);
    courierText = `- ${uploadOrders.length} Pesanan - Rp. ${numeral(uploadTotalPrice).format("0,0")}`;
  } else {
    courierText = '';
  }

  if (order.deliveryType === 'now') {
    rbText = `Pesan Sekarang ${courierText}`
  } else if (order.deliveryType === 'upload') {
    rbText = `Simpan Pengiriman ${courierText}`
  } else {
    rbText = `Simpan Pesanan ${courierText}`
  }

  if (order.paymentMethod === '') {
    let readyUpload = uploadOrders.filter(i => i.originMap === 'filled' && i.receiverMap === 'filled');
    if (order.deliveryType === 'upload' && readyUpload.length === uploadOrders.length && uploadOrders.length > 0) {
      rbClassName = ''
    } else {
      rbClassName = 'btn btn-secondary'
    }
  } else {
    rbClassName = ''
  }


  // return value
   if (modal.show && modal.type === 'map') {
     return (
         <Modal
             show={modal.show}
             onHide={closeMap}
             title={"Peta"}
             size={"md"}
             bodyClassName="p-0"
             buttons
         >
           <div ref={ref}>
             <Maps
                 zoom={15}
                 originCoordinate={modal.mapType === 'origin' ? order.originCoordinate : order.receiverCoordinate }
             />
           </div>
         </Modal>
     )
   } else if (modal.show && modal.type === 'qr') {
       return (
           <Modal
               show={modal.show}
               onHide={onCloseQR}
               title={"Pembayaran QRIS"}
               size={"sm"}
               bodyClassName="py-4 text-center"
               buttons
           >
             <div ref={ref}>
               <p> Silahkan lakukan pembayaran dengan scan QR code dibawah ini </p>
               <QRCode
                   size={156}
                   value={qrCode}
               />
               <br/>
               <p> Pembayaran QRIS dengan <b>scan QR Code</b> melalalui aplikasi OVO, Gojek, LinkAja dan lainnya yang mendukung teknologi QRIS.</p>
             </div>
           </Modal>
       )
   } else {
     return (
         <Modal
             bodyClassName="p-0"
             buttons
             footerStyle={{justifyContent: 'space-between'}}
             headerClassName={"border-0"}
             loading={order.loading}
             onHide={props.onHide}
             otherButtonComponents={ modalFooterView()}
             rbText={rbText}
             rbClassName={rbClassName}
             rbClick={() => onSubmit()}
             show={props.show && modal.type === 'order'}
             size={'xl'}
             title={"Buat Pesanan Baru"}
             type={'yesno'}
         >
           { showError() }
           { showInfo() }
           { showSuccess() }
           { deliveryTypeNav() }
           { bodyForm()}
         </Modal>
     );
   }
};


export default OrderForm;

const formatShopifyOrders = (orders) => {
  const formatted = orders.reduce((r,i) => {
    r.push({
      shopifyOrderId:i.shopify_order_id,
      shopifyFulfillmentOrderId:i.shopify_fulfillment_order_id,
      shopifyAssignedLocationId:i.shopify_assigned_location_id,
      originName:i.origin_contact_name,
      originPhone:i.origin_contact_phone,
      originLocation:i.origin_address,
      originPostalCode:i.origin_postal_code,
      originCountryCode:i.origin_country_code,
      originCoordinate:{
        latitude:i.origin_latitude,
        longitude:i.origin_longitude
      },
      originLatitude:i.origin_latitude,
      originLongitude:i.origin_longitude,
      receiverName:i.destination_contact_name,
      receiverPhone:i.destination_contact_phone,
      receiverLocation:i.destination_address,
      receiverPostalCode:i.destination_postal_code,
      receiverCountryCode:i.destination_country_code,
      receiverLatitude:i.destination_latitude,
      receiverLongitude:i.destination_longitude,
      receiverCoordinate:{
        latitude:i.destination_latitude,
        longitude:i.destination_longitude
      },
      courierCompany:i.courier_company_code,
      courierType:i.courier_service_code,
      price:i.courier_shipment_fee,
      orderItems:i.items,
    })
    return r;
  },[])
  return formatted
}

const insuranceCouriers = name => {
  let value = false;
  switch (name) {
    case 'jne':
    case 'jet':
    case 'jnt':
    case 'sicepat':
    case 'sap':
    case 'lion':
    case 'tiki':
    case 'lalamove':
    case 'gojek':
    case 'grab':
    case 'deliveree':
    case 'mrspeedy':
      value = true;
      break;
  }
  return value
};

const podCouriers = name => {
  let value = false;
  switch (name) {
    case 'deliveree':
    case 'lalamove':      
      value = true;
      break;
  }
  return value
};

const podCourierRates = name => {
  let value = false;
  switch (name) {
    case 'deliveree':  
      value = 10000;
      break;
  }
  return value
}

const codCouriers = name => {
  let value = false;
  switch (name) {
    case 'jet':
    case 'sicepat':
    case 'sap':
    case 'tiki':
      value = true;
      break;
  }
  return value
};

const pickupTime = [
  "12:00",
  "15:00",
  "18:00"
];

const weightOptions = [
    1000,
    2000,
    3000,
    4000,
    5000,
    6000,
    7000,
    8000,
    9000,
    10000
];

const itemOptions = [
    "Makanan",
    "Minuman",
    "Dokumen",
    "Baju",
    "Elektronik",
    "Kesehatan",
    "Pecah Belah",
    "Lainnya..."
];

const fullItemOptions = [
  {
    name:"Makanan",
    description:"Makanan",
    length:30,
    width:25,
    height:10,
    weight:500,
    quantity:1,
    value:99000
  },
  {
    name:"Minuman",
    description:"Minuman",
    length:10,
    width:10,
    height:35,
    weight:1000,
    quantity:1,
    value:99000
  },
  {
    name:"Dokumen",
    description:"Dokumen",
    length:30,
    width:20,
    height:1,
    weight:1000,
    quantity:1,
    value:99000
  },
  {
    name:"Baju",
    description:"Baju",
    length:20,
    width:30,
    height:2,
    weight:1000,
    quantity:1,
    value:99000
  },
  {
    name:"Elektronik",
    description:"Elektronik",
    length:15,
    width:20,
    height:10,
    weight:1000,
    quantity:1,
    value:99000
  },
  {
    name:"Kesehatan",
    description:"Kesehatan",
    length:10,
    width:10,
    height:10,
    weight:1000,
    quantity:1,
    value:99000
  },
  {
    name:"Pecah Belah",
    description:"Pecah Belah",
    length:10,
    width:10,
    height:10,
    weight:1000,
    quantity:1,
    value:99000
  },
  {
    name:"Other",
    description:"Other",
    length:10,
    width:10,
    height:10,
    weight:1000,
    quantity:1,
    value:99000
  },
];
